<template>
  <section class="main">
    <h1 class="intro">{{ $t("LIVE DEVICE STATUS") }}</h1>
    <p class="g-text">
      {{ $t("DEVICE_STATUS_DESC") }}
    </p>
    <p class="help">
      {{ $t("HAVING_TROUBLES") }}

      <span class="help__buttons">
        <button
          class="help__button g-button"
          :class="{ 'g-button_disabled': clearing }"
          @click="clear"
        >
          <loader v-show="clearing" size="15px" border="3px" absolute />
          {{ $t("EMPTY_COMMAND_QUEUE") }}
        </button>
        &nbsp;
        <button class="help__button g-button" @click="updateProfile">
          {{ $t("UPDATE PROFILE") }}
        </button>
        &nbsp;
        <a
          class="help__button g-button"
          href="https://rtfm.dbservices.to/#/troubleshooting/app-installations"
        >
          {{ $t("TROUBLESHOOTING") }}
        </a>
      </span>
    </p>
    <commands-table class="commands" :commands="commands" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/components/Loader';
import CommandsTable from '@/components/CommandsTable.vue';

export default {
  components: { Loader, CommandsTable },
  data() {
    return {
      clearing: false,
      recovering: false,
      commands: [],
      timeout: null,
    };
  },
  computed: {
    title() {
      return this.$t('LIVE DEVICE STATUS');
    },
    ...mapState(['config']),
  },
  methods: {
    clear() {
      this.clearing = true;
      this.$api.clearCommands().then(this.getStatus).finally(() => { this.clearing = false; });
    },
    updateProfile() {
      this.$globalActions.updateProfile();
    },
    async getStatus() {
      this.commands = await this.$api.getDeviceStatus();
    },
    scheduleGetStatus() {
      this.timeout = setTimeout(async () => {
        await this.getStatus();
        this.scheduleGetStatus();
      }, 1000);
    },
  },
  created() {
    this.getStatus();
    this.scheduleGetStatus();
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
}

.help {
  line-height: 28px;
  margin-top: 8px;

  &__buttons {
    display: block;
  }

  &__button {
    font-weight: 400;
    line-height: normal;
    font-family: inherit;

    @include tablet {
      margin-bottom: 8px;
    }
  }
}

.commands {
  margin-top: 15px;
}
</style>
